export default function initMenuToggle() {
    const $menuBtn = $('[menu-btn]');

    const $mobileMenu = $('[mobile-menu]');

    const $body = $('[webpage]');

    $menuBtn.click(() => {
        $mobileMenu.toggleClass('is-active');
        if ($body.hasClass('overflow-hidden')) {
            $body.removeClass('overflow-hidden');
        } else {
            $body.addClass('overflow-hidden');
        }
    });
}
